import {
    DRAWER_CLOSED, DRAWER_OPENED, SEARCH, MAP_STYLE_CHANGED, OX_MODE_CHANGED, OX_LIST_STYLE_CHANGED, LANG_CHANGED
} from "./types";

// Action creators

export const openDrawerAction = () => {
    return {
        type: DRAWER_OPENED
    }
};

export const closeDrawerAction = () => {
    return {
        type: DRAWER_CLOSED
    }
};

export const searchAction = (text) => {
    return {
        type: SEARCH,
        payload: text
    }
};

export const changeMapStyleAction = (style) => {
    return {
        type: MAP_STYLE_CHANGED,
        payload: style
    }
};

export const changeOxModeAction = (mode) => {
    return {
        type: OX_MODE_CHANGED,
        payload: mode
    }
};

export const changeOxListModeAction = (mode) => {
    return {
        type: OX_LIST_STYLE_CHANGED,
        payload: mode
    }
};
export const changeLangAction = (lang) => {
    return {
        type: LANG_CHANGED,
        payload: lang
    }
};

// Actions

export function setOxMode(mode) {
    return function (dispatch) {
        dispatch(changeOxModeAction(mode));
    }
}

export function setMapStyle(style) {
    return function (dispatch) {
        dispatch(changeMapStyleAction(style));
    }
}

export function search(text) {
    return function (dispatch) {
        dispatch(searchAction(text));
    }
}

export function openDrawer() {
    return function (dispatch) {
        dispatch(openDrawerAction());
    }
}

export function closeDrawer() {
    return function (dispatch) {
        dispatch(closeDrawerAction());
    }
}

export function setOxListMode(mode) {
    return function (dispatch) {
        dispatch(changeOxListModeAction(mode));
    }
}

export function changeLang(lang) {
    return function (dispatch) {
        dispatch(changeLangAction(lang));
    }
}



// WEBPACK FOOTER //
// src/store/ui/actions.js